import { features } from '@sparklayer-io/spark-dash-core/constants/features';
import { isShopify, useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { useFeatureEnabled } from '@sparklayer-io/spark-dash-core/hooks/use-feature-enabled';
import { SettingActionRow } from '@sparklayer-io/spark-dash-pages/components/setting-action-row';
import { SettingList } from '@sparklayer-io/spark-dash-pages/components/setting-list';
import { Card } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import { PLATFORM_DOCS_URLS } from '../constants';
import { CompanySyncRow } from './company-sync-row';

const CONFIGURATIONS_I18N =
  'features:platform.pages.platform_page.configurations' satisfies I18nPrefix;

export function ConfigurationsCard({
  onConfigureMetafields,
}: {
  onConfigureMetafields: () => void;
}) {
  const env = useEnv();

  // Companies are a Shopify B2B concept, so only Shopify stores have any to sync.
  const companySyncRow =
    useFeatureEnabled(features.COMPANY_SYNC) && isShopify(env.connected_platform);

  return (
    <Card>
      <Card.Header headingLevel="h2">{t(`${CONFIGURATIONS_I18N}.title`)}</Card.Header>
      <Card.Body>
        <SettingList>
          <SettingActionRow
            label={t(`${CONFIGURATIONS_I18N}.metafields.label`)}
            description={t(`${CONFIGURATIONS_I18N}.metafields.description`)}
            learnMoreUrl={PLATFORM_DOCS_URLS.metafields}
            actionLabel={t(`${CONFIGURATIONS_I18N}.configure`)}
            onAction={onConfigureMetafields}
          />

          {companySyncRow && <CompanySyncRow />}
        </SettingList>
      </Card.Body>
    </Card>
  );
}
